import { Helmet } from 'react-helmet';
import styles from './Communities.module.css';

export default function Communities() {
  return (
    <>
      <Helmet>
        <title>Communities | Connect with MyPeopleDatabase Users</title>
        <meta
          name="description"
          content="Join the MyPeopleDatabase communities on Facebook, YouTube, X (Twitter), and Reddit to share ideas, ask questions, and connect with other users."
        />
      </Helmet>

      <div className={styles.container}>
        <div className={styles.overlay} />
        <div className={styles.content}>
          <h1 className={styles.title}>Communities</h1>
          <p className={styles.subtitle}>
            Connect with other MyPeopleDatabase users, share workflows, and help shape what we build
            next.
          </p>

          <div className={styles.communitiesGrid}>
            <div className={styles.communityCard}>
              <h2>Facebook Group</h2>
              <p>
                Join the My People Database community group for announcements, discussion, and
                support.
              </p>
              <a
                className={styles.communityLink}
                href="https://www.facebook.com/groups/mypeopledatabaseaffiliates"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Facebook Group →
              </a>
            </div>

            <div className={styles.communityCard}>
              <h2>X / Twitter</h2>
              <p>Follow updates, release notes, and product thinking on X.</p>
              <a
                className={styles.communityLink}
                href="https://x.com/mypeopledb"
                target="_blank"
                rel="noopener noreferrer"
              >
                Follow @mypeopledb →
              </a>
            </div>

            <div className={styles.communityCard}>
              <h2>YouTube</h2>
              <p>Watch walkthroughs, updates, and tutorials from the team.</p>
              <a
                className={styles.communityLink}
                href="https://www.youtube.com/@MyPeopleDatabase"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit our YouTube channel →
              </a>
            </div>

            <div className={styles.communityCard}>
              <h2>Reddit</h2>
              <p>Ask questions, share ideas, and discover tips from the community.</p>
              <a
                className={styles.communityLink}
                href="https://www.reddit.com/r/mypeopledatabase/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit r/mypeopledatabase →
              </a>
            </div>
          </div>

          <div className={styles.peerPushSection}>
            <h2>Support Us on PeerPush</h2>
            <p>
              Love MyPeopleDatabase? Help others discover it by upvoting us on PeerPush — it only
              takes a second and makes a big difference.
            </p>
            <a
              href="https://peerpush.net/p/mypeopledatabase"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://peerpush.net/p/mypeopledatabase/badge.png"
                alt="MyPeopleDatabase on PeerPush"
                className={styles.peerPushBadge}
              />
            </a>
          </div>

          <div className={styles.ctaSection}>
            <h2>Have a Feature Request?</h2>
            <p>
              Share what you want to see next in any of the communities—or send us a direct message.
            </p>
            <div className={styles.ctaButtons}>
              <a href="/features" className={styles.secondaryButton}>
                Explore Features
              </a>
              <a href="/contact-us" className={styles.primaryButton}>
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
